import { render, staticRenderFns } from "./focus-words.vue?vue&type=template&id=d96cfdfe&scoped=true"
import script from "./focus-words.ts?vue&type=script&lang=ts&external"
export * from "./focus-words.ts?vue&type=script&lang=ts&external"
import style0 from "./focus-words.less?vue&type=style&index=0&id=d96cfdfe&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96cfdfe",
  null
  
)

export default component.exports